import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { UserAuthRole } from 'lemunzo-api';
import { RoleGuard } from 'lemunzo-shared';
import { inviteCodePathParam } from './core/constants/route-params';
import { inviteCodeGuard } from './core/guards/invite-code-guard';
import { formBackgroundResolver } from './core/resolvers/form-background.resolver';

export const routes: Routes = [
    {
        path: 'client-registration',
        loadComponent: () =>
            import('./client-registration/registration-page/registration-page.component').then(
                (c) => c.RegistrationPageComponent
            ),
        resolve: {
            backgroundData: formBackgroundResolver,
        },
        // Reload is required to fetch new bg image specific for the given case
        runGuardsAndResolvers: 'pathParamsOrQueryParamsChange',
    },
    {
        path: `client-registration/:${inviteCodePathParam}`,
        loadComponent: () =>
            import('./client-registration/password-setting/password-setting.component').then(
                (c) => c.PasswordSettingComponent
            ),
        canActivate: [inviteCodeGuard],
    },
    {
        path: 'auth',
        loadComponent: () =>
            import('./auth/auth.component').then((c) => c.AuthComponent),
        canActivate: [MsalGuard],
    },
    {
        path: 'client',
        loadChildren: () =>
            import('./client/client.routes').then((r) => r.routes),
        canActivate: [MsalGuard, RoleGuard],
        data: {
            roles: [UserAuthRole.User],
        },
    },
    {
        path: 'logout',
        loadComponent: () =>
            import('./auth/logout/logout.component').then(
                (c) => c.LogoutComponent
            ),
    },
    {
        path: 'error',
        redirectTo: 'client-registration',
    },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'auth',
    },
    {
        path: '**',
        redirectTo: 'client-registration',
    },
];
